import { render, staticRenderFns } from "./CreateUserIcon.vue?vue&type=template&id=285c0cfc"
import script from "./CreateUserIcon.vue?vue&type=script&lang=js"
export * from "./CreateUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285c0cfc')) {
      api.createRecord('285c0cfc', component.options)
    } else {
      api.reload('285c0cfc', component.options)
    }
    module.hot.accept("./CreateUserIcon.vue?vue&type=template&id=285c0cfc", function () {
      api.rerender('285c0cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/UserIcon/Modals/CreateUserIcon.vue"
export default component.exports